<!-- iot 智能监测 -->
<style lang="stylus" scoped>
.iot {
  height: 277px;
  padding: 10px 20px;
  color: #fff;

  .title {
    margin-bottom: 20px;
    color: #77CAD8;
    font-size: 16px;
  }

  .main {
    width: 100%;
    height: 100%;
  }

  .device-wrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;

    .device-item {
      position: relative;
    }

    .device-detail {
      display: inline-block;
      margin-left: 38px;
    }

    .device-name {
      margin-bottom: 5px;
      font-size: 10px;
    }

    .device-num {
      font-size: 14px;
    }
  }

  .icon {
    position: absolute;
    left: 0;
    top: 3px;
    width: 32px;
    height: 32px;
    background: url('../../../../static/img/dashboard/iot-icon.png') no-repeat;
  }

  .icon-device1 {
    background-position: 0 0;
  }

  .icon-device2 {
    background-position: -115px 0;
  }

  .icon-device3 {
    background-position: -230px 0;
  }

  .icon-device4 {
    background-position: -340px 0;
  }

  .monitor {
    width: 414px;
    height: 180px;
    display: flex;
    .monitor1,.monitor2{
      width: 204px;
      height: 180px;
      margin-right: 6px;
      overflow: hidden;
      position relative
      .swiper-wrap {
        width: 204px;
        height: 180px;

        .swiper-item {
          position: relative;
          width: 204px;
          height: 180px;

          .slide-img {
            width: 204px;
            height: 180px;
          }

          .msg {
            position: absolute;
            bottom: 0;
            width: 204px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            // background: rgba(25, 53, 177, 0.5);
            background: rgba(0, 0, 0, .5);
            color: #52FFFF;
            font-size: 16px;
            font-weight: bold;
          }
        }
      }
    }

    .swiper-button-next0, .swiper-button-prev0, .swiper-button-next1, .swiper-button-prev1 {
      width: 20px;
      height: 23px;
      top: 152px;
      position absolute;
      z-index: 1;
    }

    .swiper-button-prev0, .swiper-button-prev1 {
      background: url('../../../../static/img/base/left.png');
      background-size: 100% 100%;
      left: 4px;
    }

    .swiper-button-next0, .swiper-button-next1 {
      background: url('../../../../static/img/base/right.png');
      background-size: 100% 100%;
      left: 182px;
    }
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="iot">
      <div class="title">物联网智能硬件设备数量:</div>
      <div class="main">
        <div class="device-wrap">
          <div class="device-item">
            <i class="icon icon-device1"></i>
            <div class="device-detail">
              <div class="device-name">监控设备</div>
              <div class="device-num">365</div>
            </div>
          </div>
          <div class="device-item">
            <i class="icon icon-device2"></i>
            <div class="device-detail">
              <div class="device-name">气象站</div>
              <div class="device-num">198</div>
            </div>
          </div>
          <div class="device-item">
            <i class="icon icon-device3"></i>
            <div class="device-detail">
              <div class="device-name">传感器</div>
              <div class="device-num">298</div>
            </div>
          </div>
          <div class="device-item">
            <i class="icon icon-device4"></i>
            <div class="device-detail">
              <div class="device-name">控制设备</div>
              <div class="device-num">153</div>
            </div>
          </div>
        </div>
        <div class="monitor">
          <div class="monitor1">
            <swiper :options="swiperOption" class="swiper-wrap" v-if="imgList1.length!=0">
              <swiper-slide v-for="(item,index) in imgList1" :key="index" class="list-item">
                <div class="swiper-item">
                  <img class="slide-img" :src="item.src" alt>
                  <div class="msg">{{item.name}}</div>
                </div>
              </swiper-slide>
            </swiper>
            <div v-show="imgList1.length>1" class="swiper-button-prev0"></div>
            <div v-show="imgList1.length>1" class="swiper-button-next0"></div>
          </div>
          
          <div class="monitor2">
            <swiper :options="swiperOption1" class="swiper-wrap" v-if="imgList2.length!=0">
              <swiper-slide v-for="(item,index) in imgList2" :key="index" class="list-item">
                <div class="swiper-item">
                  <img class="slide-img" :src="item.src" alt>
                  <div class="msg">{{item.name}}</div>
                </div>
              </swiper-slide>
            </swiper>
            <div v-show="imgList2.length>1" class="swiper-button-prev1"></div>
            <div v-show="imgList2.length>1" class="swiper-button-next1"></div>
          </div>

        </div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from 'components/dashboard/common/boxWrap';
import '../../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import pro1 from '../../../../static/img/dashboard/pro1.png'
import pro2 from '../../../../static/img/dashboard/pro2.png'
import pro3 from '../../../../static/img/dashboard/pro3.png'
import pro4 from '../../../../static/img/dashboard/pro4.png'
import pro5 from '../../../../static/img/dashboard/pro5.png'
export default {
  data() {
    return {
      name: 'IOT智能监测',
      imgList1: [
        { name: '芒果园区', src: pro1 }
        // { name: '圣女果', src: pro2 }
      ],
      imgList2: [
        { name: '圣女果园区', src: pro5 }
        // { name: '圣女果', src: pro4 }
      ],
      swiperOption: {
        slidesPerView: 1,
        notNextTick: true,
        loop: true,
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next0',
          prevEl: '.swiper-button-prev0'
        },
        speed: 800,
        direction: "horizontal"
      },
      swiperOption1: {
        slidesPerView: 1,
        notNextTick: true,
        loop: true,
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next1',
          prevEl: '.swiper-button-prev1'
        },
        speed: 800,
        direction: "horizontal"
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  mounted() {

  }
}

</script>



// WEBPACK FOOTER //
// index.vue?4099bf4c